/* eslint-disable @typescript-eslint/ban-types */
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useStyles } from '../../UserManagement/UserProfileStyles'
import { Box, Button, Divider } from '@mui/material'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import { useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import { consultComplete, setCaseData } from '../../../actions'

export default function CancelConsult({ open, onClose, handleCancelConsult }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { user } = useSelector((state: RootState) => state.userLogin)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [openErrorSnackBar, setOpenErrorSnackBar] = useState(false)
  const data = useSelector((state: RootState) => state.getCaseData)
  const updateView = async () => {
    if (data) {
      await dispatch(
        setCaseData({
          pathologistId: data.pathologistId,
          pathologist: data.pathologist,
          caseNumber: data.caseNumber,
          procedureCodeId: data.procedureCodeId,
          workflowId: updateWorklowStage(data.workflowId),
          patientName: data.patientName,
          caseId: data.caseId,
          nlOrderId: data.nlOrderId,
          userCaseWorkflowId: data.userCaseWorkflowId,
          slideStatusId: data.slideStatusId,
          mcFlag: data.mcFlag,
          statFlag: data.statFlag,
        }),
      )
    }
    handleCancelConsult()
    setOpenSuccessSnackBar(true)
  }

  const updateWorklowStage = (type) => {
    switch (type) {
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT':
        return 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS'
      case 'CORRECT_ASSIGNED_CONSULT':
        return 'CORRECT_ASSIGNED_INPROGRESS'
    }
  }

  const handleCancelConsultCase = (event) => {
    dispatch(
      consultComplete({
        caseId: data.caseId,
        userId: user,
      }),
    )
    setTimeout(updateView, 1500)
  }

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      {openSuccessSnackBar && <SuccessSnackBar message="Successfully cancelled consultation" />}
      {openErrorSnackBar && <ErrorSnackBar message="Consult cancellation failed for the case" />}
      <Dialog
        fullWidth
        maxWidth="sm"
        id="hello"
        classes={{ paper: classes.dialogHeight }}
        open={open}
        onClose={onClose}
      >
        <DialogTitle className={classes.dialogTitle}>Consult Case</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText className={classes.dialogContent}>
            Confirm that you are planning to cancel consultation for this case? <br />
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button
            className={`${classes.btn} ${classes.buttonMargin}`}
            onClick={handleCancelConsultCase}
            endIcon={<CheckIcon />}
          >
            Confirm
          </Button>
          <Button onClick={onClose} variant="outlined" className={classes.buttonMargin} endIcon={<ClearIcon />}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
